
import products from '#src/configs/config.json';
import {useParams} from "react-router-dom";

export const CompanyProductsDetails = () => {

  const {feature} = useParams();


  return (
      <div className="bg-white  py-24 sm:py-32">
        <div className="lg:flex  lg:items-center  mx-auto max-w-7xl px-6 lg:px-8">
            <div >
              <div className="mx-auto text-center lg:text-left max-w-6xl ">

                <p className="mt-2 text-pretty font-semibold tracking-tight text-gray-900 sm:text-balance text-3xl">
                  {products?.features?.[feature]?.label}
                </p>

                <h2 className="text-base/7 mt-2 mb-4 font-semibold text-gray-600/60">{products?.features?.[feature]?.subLabel}</h2>

                <p className="leading-7 text-lg/8text-gray-600">
                  {products?.features?.[feature]?.description}
                </p>

                <div className={"mt-8 text-center"}>
                    <a href={"/company/license"} className={" border bg-gray-900 text-white border-gray-900 rounded-lg px-6 py-2 my-4"}>Jetzt freischalten</a>
                </div>
              </div>
            </div>
            <div className="relative overflow-hidden pb-[120px]">
              <div className="mx-auto relative max-w-7xl px-6 py-3 lg:py-4 lg:px-8">
                  <img
                    alt="App screenshot"
                    src={`${process.env.PUBLIC_URL}/${products?.features?.[feature].imagesMain}`}
                    width={2432}
                    height={1842}
                    className="mb-[-12%]  mt-12 lg:mt-0 rounded-xl shadow-2xl ring-1 ring-gray-900/10"
                  />

              </div>
            </div>
        </div>


        { (typeof products?.features?.[feature]?.example !== "undefined") && (
              <div className=" mx-auto max-w-7xl px-6 lg:px-8">
                  <div>
                      <h2 className="text-xl  mt-12 mb-4 font-semibold text-gray-900">{products?.features?.[feature]?.example?.label}</h2>
                      <p className="text-base mt-2 mb-4 font-semibold text-gray-600/60">{products?.features?.[feature]?.example?.description}</p>

                  </div>

                  <iframe
                    src={products?.features?.[feature]?.example?.iframe}
                    className={"w-full h-[800px] border-gray-500 rounded border"}
                    title={`Example for ${products?.features?.[feature]?.example?.label || feature}`}
                  ></iframe>
              </div>
        ) }



      </div>
  )
}
